export default class {
  constructor(path = []) {
    this.path = path
    this.key = Math.random().toString(36).substring(7)
  }

  isValid() {
    return this.path.length >= 3
  }
}
